export default "__VITE_ASSET__CI1z94oX__"